import React from "react";

import TextMask from "react-text-mask";

export default class InputPhoneNumberLogin extends React.Component {
  render() {
    const {
      input,
      className,
      meta: { touched, error },
    } = this.props;
    return (
      <div className="position-relative w-100">
        <TextMask
          {...input}
          mask={[
            /[0-9]/,
            /\d/,
            /\d/,
            /\d/,
            " ",
            /\d/,
            /\d/,
            /\d/,
            " ",
            /\d/,
            /\d/,
            /\d/,
          ]}
          className={className || 'form-control'}
          type="text"
          placeholder="Nhập số điện thoại"
          style={{
            borderColor: `${touched && error ? "#FF0000" : "transparent"}`,
          }}
        />
        {touched && error && (
          <div
            style={{
              color: "#FF0000",
              margin: "0 0 10px",
              fontSize: "0.75rem",
            }}
          >
            {error}
          </div>
        )}
      </div>
    );
  }
}
